Vue.asyncComponent('ak-placeholder-list', {
    props: {
        show: {
            type: String,
        },
        highlightedIndex: {
            type: Number,
        },
        placeholders: {
            type: Array,
        }
    },
    methods: {
        insertPlaceholder(placeholder) {
            this.$emit('insertPlaceholder', placeholder);
        }
    }
}, 'form/controls/partials/ak-placeholder-list.html');